"use client";

import { useEffect } from "react";
import posthog from "posthog-js";
import type { Product } from "@/types";

interface ProductViewTrackerProps {
  product: Product;
}

export function ProductViewTracker({ product }: ProductViewTrackerProps) {
  useEffect(() => {
    posthog.capture("product_viewed", {
      product_id: product.id,
      category: product.category,
      seller_id: product.sellerId,
      price: product.price,
      currency: "PLN",
    });
  }, [product.id, product.category, product.sellerId, product.price]);

  return null;
}
